import { Role } from './models';

export const rolesToRolesMap = (roles: Role[]) => roles.reduce(
  (dict, role) => ({
    ...dict,
    [role.roleName]: role
  }),
  {}
);
